<app-foi [isCourtexView]="true"></app-foi>